// extracted by mini-css-extract-plugin
module.exports = {"recipe":"recipe_recipe__1-wYq","image":"recipe_image__2fmZd"};